import React from 'react';

export type UseMenuProps = {
  onClose?(): void;
};

export const useMenu = ({ onClose }: UseMenuProps = {}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) {
      onClose();
    }
  };

  return {
    anchorEl,
    open,
    handleOpen,
    handleClose,
  };
};
